import { render, staticRenderFns } from "./BasemapCard.vue?vue&type=template&id=649c7554&"
import script from "./BasemapCard.vue?vue&type=script&lang=js&"
export * from "./BasemapCard.vue?vue&type=script&lang=js&"
import style0 from "./BasemapCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VImg,VSelect,VSheet})
